import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    Component: Outlet,
    handle: { context: CONTEXTS.PROFILE, title: 'Mon profil' },
  },
  {
    path: 'profile/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.PROFILE_EDIT, title: 'Modifier le profil' },
  },
];
